module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-14.2fe9972c.png";